import './Main.scss';

const Main = () => {
  return (
    <main className="container">
      <div className="main">
        <div className="title-blok">
          <h1 className="title">Welcome to Magic Marks!</h1>
          <button type="button" className="log-in__btn">Log in</button>
        </div>
        <div className="main-img" />
      </div>
    </main>
  );
};
export default Main;
